import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../App';

export default function Login() {
  const [form, setForm] = useState({ login: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { signIn } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      // Admin login uses JWT_SECRET as password for simplicity
      // In production you'd have a real admin user system
      const res = await fetch('/api/admin/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Erreur');
      signIn(data.token, data.name, form.password, data.role || 'admin', data.pages || null, data.role_name || '');
      navigate('/');
    } catch (err) {
      if (err instanceof TypeError || err.message === 'Failed to fetch') {
        setError('Impossible de contacter le serveur — réessayez dans quelques secondes.');
      } else {
        setError(err.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)', padding: 20 }}>
      <div style={{ width: '100%', maxWidth: 380 }}>
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <div style={{ width: 52, height: 52, borderRadius: '50%', background: 'var(--accent)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 24, fontWeight: 900, color: '#fff', marginBottom: 16 }}>V</div>
          <div style={{ fontSize: 24, fontWeight: 800, letterSpacing: '-.5px', marginBottom: 6 }}>VALEA Admin</div>
          <div style={{ color: 'var(--text2)', fontSize: 14 }}>Panel de contrôle</div>
        </div>
        <div className="card">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Identifiant</label>
              <input className="form-input" type="text" value={form.login} onChange={e => setForm(f => ({ ...f, login: e.target.value }))} placeholder="admin" required autoFocus />
            </div>
            <div className="form-group">
              <label className="form-label">Mot de passe</label>
              <input className="form-input" type="password" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} placeholder="••••••••" required />
            </div>
            {error && <div className="alert alert-error">{error}</div>}
            <button className="btn btn-primary" type="submit" disabled={loading} style={{ width: '100%', justifyContent: 'center', padding: '11px', fontSize: 14 }}>
              {loading ? <span className="spinner" /> : 'Connexion'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
